import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import React from 'react'
import { TooltipPortal } from '@radix-ui/react-tooltip'
import { cn } from '@/lib/utils'

export default function TruncatedLabel({ text, className = '' }) {
  const textRef = React.useRef<HTMLDivElement | null>(null)
  const [isTextTruncated, setIsTextTruncated] = React.useState(false)

  const checkTruncation = React.useCallback(() => {
    if (textRef.current) {
      setIsTextTruncated(
        textRef.current.scrollWidth > textRef.current.clientWidth,
      )
    }
  }, [])

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            ref={textRef}
            onMouseEnter={checkTruncation}
            className={cn(
              'w-full cursor-pointer  truncate text-txt-primary',
              className,
            )}
          >
            {text}
          </div>
        </TooltipTrigger>
        {isTextTruncated && (
          <TooltipPortal>
            <TooltipContent align="center">
              {text}
              <TooltipArrow />
            </TooltipContent>
          </TooltipPortal>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
